import React, { useEffect, useState } from 'react'
import recentInvitations from "../../apis/recentInvitationsAPI/recentInvitations"
import getTrackCandidateInfo from "../../apis/getTrackCandidateInfo/getTrackCandidateInfo";
import Tooltip from '@mui/material/Tooltip';
import './RecentTestTaken.css';

const RecentTestTaken = ({ idContextTest, userType, userRecruitmentpartnerId, userRecords, userRole }) => {

    const [RecentInvitationData, setRecentInvitationData] = useState([]);

    const getRecentInvitations = async () => {
        try {
            let response = await recentInvitations({
                id: idContextTest,
                userType: userType === 'Admin' ? userRole : userType,
                recruitmentpartnerId: userRecruitmentpartnerId
            });
            setRecentInvitationData(response?.data?.data || []);
        } catch (error) {
            console.log("error", error);
        }
    };

    useEffect(() => {
        getRecentInvitations();
    }, [userType]);


    const getInitials = (name) => {
        if (!name) return "";
        const words = name.trim().split(" ");
        if (words.length === 1) {
            return words[0].substring(0, 2).toUpperCase();
        }
        return (words[0][0] + words[1][0]).toUpperCase();
    };

     const goToCandidateProfile = async (itemValue) => {
        const response = await getTrackCandidateInfo({
            candidateEmail: itemValue.candidateEmail,
            recruitmentPartnerId: userRecruitmentpartnerId
        });
        const userData = response?.data?.data?.userDetails[0]
        let url = '';
        if (userData?.powerResumeId) {
            url = 'candidate/profile/' + userData?.powerResumeId + '/' + userData.recruitmentOrgId
        }
        else {
            url = 'only-candidate-profile/' + userData?.candidateId
        }
        window.open(url, "_blank")
    }

    return (
        <div className="bento bento-extra-tall">
            <div className="bento-header">
                <div className="bento-header-content">
                    <div className="bento-header-text">
                        <span>Recent Test Taken</span>
                    </div>
                </div>
            </div>
            <ul className="recent-list-items" >
                {RecentInvitationData.length > 0 ? (
                    RecentInvitationData.map((item, index) => (
                        <li key={index} onClick={(e) => goToCandidateProfile(item)}>
                            <div className="user_card">
                                <div className="avatar_wrapper">
                                    <div className="avatar_fallback">
                                        {getInitials(item?.candidateName)}
                                    </div>
                                </div>

                                <div className="user_content_recentTestTaken">
                                    <div className="user_name_title">
                                        <Tooltip title={item?.candidateName || ""} arrow>
                                            <p className="user_name">{item?.candidateName}</p>
                                        </Tooltip>
                                        <Tooltip title={item?.testName || ""} arrow>
                                            <p className="user_title">{item?.testName}</p>
                                        </Tooltip>
                                    </div>

                                    <div className="user_meta">
                                        <Tooltip title={`Invited By: ${item?.InvitedBy || ""}`} arrow>
                                            <span className="badge">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" stroke="currentColor" strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                                    <path d="m9 11 3 3L22 4"></path>
                                                </svg>
                                                Invited By: {item?.InvitedBy}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))
                ) : (
                    <div className="ats-dashFeed-RightBar-InfoCard">
                        <div style={{ fontWeight: "600" }}>No Invitations Found</div>
                    </div>
                )}
            </ul>
        </div>
    );
};

export default RecentTestTaken;

